interface LoadingSpinnerProps {
  size?: 'sm' | 'md' | 'lg';
  label?: string;
  fullScreen?: boolean;
}

export function LoadingSpinner({
  size = 'md',
  label = 'Loading...',
  fullScreen = true,
}: LoadingSpinnerProps) {
  const sizeMap = { sm: 20, md: 32, lg: 48 };
  const px = sizeMap[size];

  return (
    <div
      className={
        fullScreen
          ? 'min-h-screen flex items-center justify-center bg-background'
          : 'flex items-center justify-center py-8'
      }
      role="status"
      aria-label={label}
    >
      <svg
        className="animate-spin text-primary-fixed-dim"
        width={px}
        height={px}
        viewBox="0 0 24 24"
        fill="none"
      >
        <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" opacity="0.25" />
        <path
          fill="currentColor"
          d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
          opacity="0.75"
        />
      </svg>
      <span className="sr-only">{label}</span>
    </div>
  );
}
